import React from "react"
import strings from "../../localization/strings"
import { Dialog, FlatButton, Table, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableBody } from "material-ui"
import { IUIUser } from "../../models"
import ErrorIcon from "material-ui/svg-icons/alert/error"
import { red500 } from "material-ui/styles/colors"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
interface IProps {
    jobName: string
    results: IUIUser[]
    handleClose(): void
    handleProceed(): void
}

const JobHierarchyMoveWarningDialog: React.SFC<IProps> = (props: IProps) => {
    return (
        <Dialog
            open
            autoScrollBodyContent
            title={strings.Job_Hierarchy_Move}
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            actions={[
                <FlatButton
                    key="cancel"
                    label={strings.Cancel}
                    primary
                    onClick={props.handleClose}
                />,
                <FlatButton
                    key="proceed"
                    label={strings.Proceed}
                    secondary
                    onClick={props.handleProceed}
                />
            ]}
        >
            <div>
                <div style={{ marginBottom: 15 }}>
                    {strings.formatString(strings.Job_Hierarchy_Move_Warning, props.jobName)}
                </div>
                <Table selectable={false}>
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        enableSelectAll={false}
                    >
                        <TableRow style={{ height: 40 }}>
                            <TableHeaderColumn style={{ alignItems: "center", padding: 0, height: 40, width: 50, textAlign: "center" }}>
                                <ErrorIcon style={{ color: red500, width: 25, height: 25, marginTop: 7 }} />
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: 0, height: 40, textAlign: "left" }}>
                                {strings.Name}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: 0, height: 40, textAlign: "left" }}>
                                {strings.Employee_ID}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: 0, height: 40, textAlign: "left" }}>
                                {strings.Punch_Permission_Hierarchy}
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {props.results.map((result, index) =>
                            <TableRow key={index} style={{ height: 30, borderBottom: "none" }}>
                                <TableRowColumn style={{ padding: 0, height: 30, width: 50, textAlign: "center" }}>
                                    {`${index + 1})`}
                                </TableRowColumn>
                                <TableRowColumn style={{ padding: 0, height: 30, textAlign: "left" }}>
                                    {`${result.FirstName} ${result.LastName}`}
                                </TableRowColumn>
                                <TableRowColumn style={{ padding: 0, height: 30, textAlign: "left" }}>
                                    {result.ExternalId}
                                </TableRowColumn>
                                <TableRowColumn style={{ padding: 0, height: 30, textAlign: "left" }}>
                                    {hierarchyHelper.getFullyQualifiedLevelNameById(result.DefaultHierarchyItemId)}
                                </TableRowColumn>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </Dialog>
    )
}

export default JobHierarchyMoveWarningDialog